import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { Department } from './clinicHelper';


interface ViewDepartmentDetailsProps {
  departments: Department[];
  onBack: () => void;
  // stores?: string[];
}

const ViewDepartmentDetails: React.FC<ViewDepartmentDetailsProps> = ({ departments,onBack }) => {

  return (
    <Box>
      {/* Departments */}
      <Typography variant="subtitle2" sx={{ color: '#BBBBBB', fontWeight: 500, mb: 0.5 }}>
        Departments
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
        {departments && departments.length > 0
          ? departments.map(dep => dep.name).join(' | ')
          : '-'}
      </Typography>
      {/* Stores */}
      {/* ...existing code... */}
      {/* // Action Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, mt: 14 }}>
        <Button variant="outlined" sx={{ fontWeight: 700, borderRadius: 2, px: 3, py: 1 }} onClick={onBack}>Back to List</Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#3e3e3e',
            color: '#fff',
            fontWeight: 700,
            boxShadow: 'none',
            borderRadius: 2,
            px: 3,
            py: 1,
            '&:hover': { backgroundColor: '#222' },
          }}
          onClick={() => {
          //   if (clinic && clinic.id) {
          //     navigate(`/ai/configuration/clinic/${clinic.id}`);
          //   }
          }}
        >
          Edit Details
        </Button>
      </Box>
    </Box>
  );
};

export default ViewDepartmentDetails;
